import React from 'react';
import { Link } from 'react-router-dom';
import guides from '../data/guides';
import { guideTone } from '../data/tones';
import { IconArrowRight } from '../components/Icons';

export default function GuidesIndex() {
  return (
    <>
      <div className="page-head">
        <p className="eyebrow">Reference</p>
        <h1 className="page-title">Growing guides</h1>
        <p className="page-lede">
          In-depth notes on raising, pruning and planting - written for this garden,
          with links through to specialist growers for further reading.
        </p>
      </div>

      <div className="guide-index">
        {guides.map(guide => (
          <Link to={`/guides/${guide.slug}`} key={guide.slug} className={`guide-index__card ${guideTone(guide.category)}`}>
            <span className="tag">{guide.category}</span>
            <h2>{guide.title}</h2>
            <p>{guide.summary}</p>
            <span className="link-arrow">Read guide <IconArrowRight size={14} /></span>
          </Link>
        ))}
      </div>
    </>
  );
}
